import type { Options } from './wasmBridge/viewModel';
import type { GameOptionDefinition } from './settings-catalog';

function optionValue(options: Options[], index: number): number | boolean | undefined {
  return options.find(option => option.index === index)?.value;
}

/**
 * Resolve the display label for a choice option (e.g. Difficulty, Board type)
 * from the backend settings catalog — the single source of truth for choice
 * labels. The stored option value is the numeric choice index.
 */
function choiceLabel(
  definitions: GameOptionDefinition[],
  index: number,
  value: number | boolean | undefined
): string {
  const definition = definitions.find(option => option.index === index && option.type === 'choices');
  return definition?.choices?.[value as number] ?? String(value);
}

export function autoName(
  puzzle: string,
  options: Options[],
  definitions: GameOptionDefinition[] = []
): string {
  switch (puzzle) {
    case 'map': {
      const width = optionValue(options, 0);
      const height = optionValue(options, 1);
      const regions = optionValue(options, 2);
      return `${width}×${height}, ${regions} regions, ${choiceLabel(definitions, 3, optionValue(options, 3))}`;
    }
    case 'pegs': {
      const width = optionValue(options, 0);
      const height = optionValue(options, 1);
      return `${width}×${height} ${choiceLabel(definitions, 2, optionValue(options, 2))}`;
    }
    case 'rectangles': {
      const width = optionValue(options, 0);
      const height = optionValue(options, 1);
      return `${width}×${height}`;
    }
    case 'tents': {
      const width = optionValue(options, 0);
      const height = optionValue(options, 1);
      return `${width}×${height}, ${choiceLabel(definitions, 2, optionValue(options, 2))}`;
    }
    case 'unruly': {
      const width = optionValue(options, 0);
      const height = optionValue(options, 1);
      const unique = optionValue(options, 2);
      const base = `${width}×${height}`;
      const difficulty = choiceLabel(definitions, 3, optionValue(options, 3));
      return unique ? `${base}, unique, ${difficulty}` : `${base}, ${difficulty}`;
    }
    case 'untangle': {
      const vertices = optionValue(options, 0);
      return `${vertices} vertices`;
    }
    default:
      return '';
  }
}
